import frag from '../shaders/main.frag';
import vert from '../shaders/main.vert';

function createDrawPoints(regl, points) {
  let positionStart = [];
  let positionEnd = [];
  let colorStart = [];
  let colorEnd = [];
  let index = [];
  // Rather than mapping over the points
  // for each attribute, we'll do one forEach
  points.forEach((p, i) => {
    positionStart.push([ p.sx, p.sy ]);
    positionEnd.push([ p.tx, p.ty ]);
    colorStart.push(p.colorStart);
    colorEnd.push(p.colorEnd);
    index.push(i);
  });

  return regl({
    frag,
    vert,
    count: points.length,
    primitive: 'points',

    attributes: {
      positionStart,
      positionEnd,
      colorStart,
      colorEnd,
      index,
    },

    uniforms: {
      pointWidth: regl.prop('pointWidth'),
      stageWidth: regl.prop('stageWidth'),
      stageHeight: regl.prop('stageHeight'),
      delayByIndex: regl.prop('delayByIndex'),
      duration: regl.prop('duration'),
      elapsed: ({ time }, { startTime = 0 }) => (time - startTime) * 1000,
    },
  });
}

export default createDrawPoints;



// WEBPACK FOOTER //
// ./src/helpers/drawPoints.js